import React from "react";
import { Button, Col, Row } from "reactstrap";
import { handleRequestError } from "../../../../../utils/helpers";
import {
  infoNotification,
  successNotification
} from "../../../../../utils/notifications";
import { changeToMonthlyPaymentMode } from "../../../../actions/partners";
import ConfirmModal from "../../../common/confirmModal/confirmModal";

interface Partner {
  idMembresiaSocio: string;
  idPersona: string;
  idPropietario: string;
}

interface Props {
  partner: Partner;
  reload: () => any;
}

class CambiarPagoMensual extends React.Component<Props> {
  state = {
    isOpen: false,
    waiting: false
  };

  executeChangeToMonthlyPaymentMode = () => {
    const { idMembresiaSocio: membresiaSocioId } = this.props.partner;

    this.setState({ waiting: true });

    infoNotification("Cambiando a forma de pago mensual...");

    changeToMonthlyPaymentMode(membresiaSocioId)
      .then(({ data }) => {
        successNotification("Se cambió a forma de pago mensual");

        this.clearState();
        this.props.reload();
      })
      .catch((err: any) => {
        this.setState({ waiting: false });
        handleRequestError(err);
      });
  };

  clearState = () => {
    this.setState({
      isOpen: false,
      cancelMessages: [],
      cancelCharges: [],
      reasonToCancel: null,
      waiting: false
    });
  };

  render() {
    return (
      <div>
        <ConfirmModal
          title="Cambiar a pago mensual"
          message="Se cambiará a pago mensual la membresía socio actual. No se podrá regresar a pago anual a menos que realice una recotización.  ¿Desea continuar?"
          isOpen={this.state.isOpen}
          size="md"
          waiting={!!this.state.waiting}
          ok={() => {
            this.executeChangeToMonthlyPaymentMode();
          }}
          cancel={() => {
            this.setState({
              isOpen: false,
              waiting: false
            });
          }}
        />

        <Row className="p-0 m-0">
          <Col xs={4}>
            <Button
              block
              onClick={() => {
                this.setState({ isOpen: true });
              }}
              className="mt-3"
            >
              Cambiar a forma de pago Mensual
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}

export default CambiarPagoMensual;
